import React, { type FC, useEffect } from 'react'
import type { MessageProps } from '../../utility/types'

const Message: FC<MessageProps> = ({ message, color = 'red', clearMessage, className = '', persistent = false }) => {
  useEffect(() => {
    // Persistent messages never auto-clear
    if (message && color !== 'red' && !persistent) {
      const timer = setTimeout(clearMessage, 3000)
      return () => { clearTimeout(timer) }
    }
  }, [message, clearMessage, color, persistent])

  const handleClick = () => {
    if (color === 'red') {
      // Copy to clipboard for convenience, but only dismiss when not persistent
      navigator.clipboard.writeText(message).then(() => {
        if (!persistent) {
          clearMessage()
        }
      })
    }
  }

  const baseClasses = 'transition-opacity duration-300 ease-in-out inline-block'
  const colorClasses = {
    red: 'text-red-500 bg-red-100',
    green: 'text-green-500 bg-green-100',
    yellow: 'text-yellow-500 bg-yellow-100'
  }

  const combinedClasses = `${baseClasses} ${colorClasses[color]} ${className ?? ''}`.trim()

  return (
    <span className={combinedClasses} onClick={handleClick}>
      {message}
     </span>
  )
}

export default Message
